import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

//Pages
import App from "./App";
import Home from "./pages/Home";
import LoginPage from "./pages/auth/LoginPage";
import RecoveryPage from "./pages/auth/RecoveryPage";
import MissingPage from "./pages/extra/MissingPage";
import DevicesLayout from "./pages/dashboard/devices/DevicesLayout";
import CollectionsLayout from "./pages/dashboard/collections/CollectionsLayout";
import ScreeningsLayout from "./pages/dashboard/collections/screenings/ScreeningsLayout";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="/" element={<Home />} />
          <Route path="auth/login" element={<LoginPage />} />
          <Route path="auth/recovery" element={<RecoveryPage />} />
          <Route path="dash/devices" element={<DevicesLayout />} />
          <Route path="dash/devices/:deviceId/collection" element={<CollectionsLayout />} />
          <Route path="dash/devices/:deviceId/collection/:collectionId/screenings" element={<ScreeningsLayout />} />
        </Route>
        <Route
          path="*"
          element={<MissingPage/>}
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
